import React from "react";

const styles = {
  container: {
    minHeight: "80vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    color: "white",
    gap: "1rem",
    padding: "2rem 1rem"
  },
  badge: {
    fontSize: "2rem",
    background: "rgba(184,111,255,0.2)",
    padding: "1rem 1.5rem",
    borderRadius: 999,
    border: "1px solid rgba(184,111,255,0.7)"
  },
  title: {
    margin: 0,
    fontSize: "2.8rem",
    fontWeight: 700
  },
  description: {
    margin: 0,
    maxWidth: 640,
    color: "#c6c8d5",
    lineHeight: 1.6
  }
};

const UseExecutionPage = () => (
  <section style={styles.container}>
    <div style={styles.badge}>🚧</div>
    <h1 style={styles.title}>Use Case Execution & Experience</h1>
    <p style={styles.description}>
      We’re building the Use Case Execution experience right now. Come back soon to see how an intelligent,
      under-construction environment can launch your bot workspaces into production.
    </p>
    <p style={styles.description}>In the meantime, feel free to explore the other sections while we put the finishing touches on this one.</p>
  </section>
);

export default UseExecutionPage;
